export default __webpack_public_path__ + "img/Image-403@2x.3d814f73b7d62048c3f25e5458022cde.png";